import { MessageCircle } from "lucide-react";
import { resolveSite } from "../lib/siteConfig";
import { usePublicData } from "../hooks/usePublicData";
import { useLanguage } from "../context/LanguageContext";
import { trackWhatsappClick } from "../lib/tracking";

export default function WhatsAppButton() {
  const { settings } = usePublicData();
  const site = resolveSite(settings);
  const { t, language } = useLanguage();
  return (
    <a
      data-testid="floating-whatsapp"
      href={site.whatsappLink(t("whatsapp.floatingMessage"))}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsappClick("floating", { language })}
      className="fixed bottom-[max(7rem,calc(env(safe-area-inset-bottom,0px)+5.25rem))] right-3 z-40 group overflow-hidden sm:bottom-[max(1.5rem,calc(env(safe-area-inset-bottom,0px)+1rem))] md:bottom-8"
      aria-label={t("whatsapp.aria")}
    >
      <span className="absolute inset-0 bg-[#25D366] blur-lg opacity-40 group-hover:opacity-70 transition-opacity" />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1faa54] text-black font-bold px-4 py-3 shadow-2xl transition-all group-hover:-translate-y-0.5">
        <MessageCircle className="w-5 h-5" strokeWidth={2.4} />
        <span className="hidden sm:inline text-sm uppercase tracking-wider">{t("whatsapp.brand")}</span>
      </span>
    </a>
  );
}
